import api from 'api'

export type HealthStipendOutcome =
  | 'paid'
  | 'already_paid'
  | 'below_minimum_hours'
  | 'no_driving_hours'

export type PayHealthStipendRequest = {
  /** First day of a quarter that has ended, formatted as `yyyy-MM-dd`. */
  quarterStartDate: string
  workerId: number
  overrideVelocityControls: boolean
}

export type PayHealthStipendResponse = {
  outcome: HealthStipendOutcome
  avgEngagedHoursPerWeek: number | null
  amount: string
  userPaymentId: number | null
}

export const payHealthStipend = async (
  request: PayHealthStipendRequest
): Promise<PayHealthStipendResponse> => {
  const response = await api.post('/admin/payment/health_stipend', request)
  return response.data
}
